import React from "react";
import { Layout, Row, Col, Typography, Space, Button, Tooltip } from "antd";
import {
  MailOutlined,
  LinkedinOutlined,
  GithubOutlined,
  TwitterOutlined,
  HeartOutlined,
  RocketOutlined,
  StarOutlined,
} from "@ant-design/icons";

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear() || 2025;

  return (
    <AntFooter
      className="glass-footer-cool"
      style={{ textAlign: "center", padding: "40px 50px 24px" }}
    >
      {/* Floating decorative elements */}
      <div className="footer-floating-elements">
        <div className="floating-star star-1">
          <StarOutlined />
        </div>
        <div className="floating-star star-2">
          <StarOutlined />
        </div>
        <div className="floating-star star-3">
          <StarOutlined />
        </div>
        <div className="floating-heart heart-1">
          <HeartOutlined />
        </div>
        <div className="floating-heart heart-2">
          <HeartOutlined />
        </div>
        <div className="floating-rocket rocket-1">
          <RocketOutlined />
        </div>
      </div>

      <Row gutter={[32, 24]} justify="center" className="footer-content">
        <Col xs={24} sm={12} md={8}>
          <div className="footer-section">
            <div className="section-header">
              <Text
                className="glass-text-cool"
                style={{ fontSize: "20px", fontWeight: "bold" }}
              >
                Ruhul Amin Parvez
              </Text>
            </div>
            <div className="section-content">
              <Text className="glass-text-secondary-cool">
                Software Engineer at{" "}
                <a
                  href="https://seedlink.vc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link"
                >
                  Seedlink Innovation
                </a>
              </Text>
              <div className="role-badge">
                <span>🚀 Full Stack Developer</span>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <div className="footer-section">
            <div className="section-header">
              <Text
                className="glass-text-secondary-cool"
                style={{ fontSize: "16px", fontWeight: "600" }}
              >
                Get In Touch
              </Text>
            </div>
            <div className="section-content">
              <Tooltip title="Send me an email" placement="top">
                <Button
                  type="text"
                  icon={<MailOutlined />}
                  className="contact-button"
                  href="mailto:ruhul15-10419@diu.edu.bd"
                >
                  Email Me
                </Button>
              </Tooltip>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <div className="footer-section">
            <div className="section-header">
              <Text
                className="glass-text-secondary-cool"
                style={{ fontSize: "16px", fontWeight: "600" }}
              >
                Connect With Me
              </Text>
            </div>
            <div className="section-content">
              <Space size="large" className="social-links">
                <Tooltip title="LinkedIn Profile" placement="top">
                  <Link
                    href="https://linkedin.com/in/ruhulaminparvez"
                    target="_blank"
                    className="social-link linkedin"
                  >
                    <LinkedinOutlined />
                  </Link>
                </Tooltip>
                <Tooltip title="GitHub Profile" placement="top">
                  <Link
                    href="https://github.com/ruhulaminparvez"
                    target="_blank"
                    className="social-link github"
                  >
                    <GithubOutlined />
                  </Link>
                </Tooltip>
                <Tooltip title="Twitter Profile" placement="top">
                  <Link
                    href="https://twitter.com/ruhulaminparvez"
                    target="_blank"
                    className="social-link twitter"
                  >
                    <TwitterOutlined />
                  </Link>
                </Tooltip>
              </Space>
            </div>
          </div>
        </Col>
      </Row>

      <div className="footer-divider">
        <div className="divider-line"></div>
        <div className="divider-icon">
          <HeartOutlined />
        </div>
        <div className="divider-line"></div>
      </div>

      <div className="footer-bottom">
        <Text className="glass-text-muted-cool">
          © {currentYear} Ruhul Amin Parvez. Crafted with{" "}
          <HeartOutlined className="heart-icon" /> and lots of ☕
        </Text>
        <div className="footer-tagline">
          <Text className="glass-text-secondary-cool">
            Building the future, one line of code at a time
          </Text>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
